<script>
import { l } from 'src/utils';

export default {
  props: ['value'],
  data() {
    return {
      password: '',
      fetching: false,
      error: false,
      isButtonDisabled: true,
      isResolving: false,
    };
  },
  watch: {
    password() {
      this.checkPassword();
    },
  },
  methods: {
    async resolve(answer) {
      if (this.isResolving) {
        return;
      }
      this.isResolving = true;

      try {
        await this.value.resolve(answer ? this.password : false);
      } catch (error) {
        l.error(error);
      } finally {
        this.isResolving = false;
      }
    },
    checkPassword() {
      this.isButtonDisabled = !this.password;
      this.clearError();
    },
    clearError() {
      this.error = false;
    },
  },
};
</script>

<template lang="pug">
  div(:class="$style.form")
    div(:class="$style.header") {{ $t('T_ENTER_PASSWORD_RESET_CONFIRMATION') }}
    div(:class="$style.content")
      span(:class="$style.text") {{ $t('T_CONFIRMATION_CODE') }}
      ui-field(
        v-model="password",
        @input="clearError",
        :label= "$t('T_VERIFY_CODE')",
        name="password",
        required,
        :disabled="fetching",
        :error="error",
        :maxlength="20")
      div(:class="$style.actionBtn")
        ui-button(colored="green", @click.native="resolve(true)", :disabled="isButtonDisabled",
          @keyup.enter.native="resolve(true)")  {{ $t('T_OK') }}
        ui-button(colored="red", @click.native="resolve(false)",
          @keyup.enter.native="resolve(false)")  {{ $t('T_CANCEL') }}
</template>

<style lang="sass" module>
.form
  background: #fff
  border-radius: 3px
  box-sizing: border-box
  padding: 24px 30px 30px
  min-width: 460px
  flex-grow: 1
  max-width: 100%
  position: relative
  overflow: hidden
  box-shadow: $sh_dp16
  @media (max-width: 460px)
    border-radius: 0
  &Actions
    padding-top: 16px
    text-align: center
.loading
  position: absolute
  left: 0
  right: 0
  bottom: 0
.actionBtn
  display: flex
  justify-content: center
  gap: 50px
  padding-top: 30px
.header
  display: flex
  justify-content: center
  max-width: 600px
  font-size: 18px
  padding-bottom: 30px
</style>
